import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CARD_TYPE_POSTER } from 'helpers/ContentHelper';
import { Poster, WATCHLIST_POSTER } from 'componentsV2/Poster';
import Grid from 'componentsV2/Grid';
import { fetchNextPage } from '../../WatchlistHelper';

import Style from './WatchlistResult.module.scss';

const WatchlistResult = ({
  account,
  breakpoint,
  checkedItems,
  favoritesManager,
  isMobileEditActive,
  nextUrl,
  setCheckedItems,
  setNextUrl,
  setWatchlistItems,
  watchlistCount,
  watchlistItems,
}) => {
  const lastElementRef = useRef(null);
  const nextPage = useRef(nextUrl);
  const observer = useRef(
    new window.IntersectionObserver(entries => {
      const first = entries[0];
      if (first?.isIntersecting && nextPage.current) {
        fetchNextPage({ account, nextUrl: nextPage.current, setWatchlistItems, setNextUrl });
      }
    }),
  );

  useEffect(() => {
    nextPage.current = nextUrl;
  }, [nextUrl]);

  useEffect(() => {
    const currentElement = lastElementRef.current;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, []);

  const renderPoster = items =>
    items?.map((item, index) => (
      <Poster
        account={account}
        breakpoint={breakpoint}
        checkedItems={checkedItems}
        favoritesManager={favoritesManager}
        isGrid
        isMobileEditActive={isMobileEditActive}
        item={item}
        itemIndex={index}
        setCheckedItems={setCheckedItems}
        type={WATCHLIST_POSTER}
      />
    ));

  return (
    <>
      <Grid type={CARD_TYPE_POSTER}>{renderPoster(watchlistItems)}</Grid>
      <div
        ref={lastElementRef}
        aria-hidden
        className={classNames(watchlistCount ? Style.showLastEle : Style.hideLastEle)}
      />
    </>
  );
};

WatchlistResult.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  checkedItems: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({}),
  isMobileEditActive: PropTypes.bool,
  nextUrl: PropTypes.string,
  setCheckedItems: PropTypes.func,
  setNextUrl: PropTypes.func,
  setWatchlistItems: PropTypes.func,
  watchlistCount: PropTypes.number,
  watchlistItems: PropTypes.arrayOf(PropTypes.shape({})),
};

export default WatchlistResult;
